import { Box, DashboardModuleListItem } from '@domain-group/suit-theme'

import type { CampaignModel } from '@models/campaign'

import CampaignImage from '@components/CampaignImage'

interface SelectedCampaignProps {
  campaign: CampaignModel,
}

const SelectedCampaign = (props: SelectedCampaignProps) => {
  const { campaign, campaign: { address, suburb_name } } = props

  return (
    <DashboardModuleListItem
      boxProps={{ padding: 0 }}
      hideAngleIcon
      imageComponent={(
        <Box marginRight="large" width="fit-content">
          <CampaignImage
            borderRadius={5}
            campaign={campaign}
            height={40}
            width={65}
          />
        </Box>
        )}
      isSidebar
      secondaryText={suburb_name}
      title={address}
    />
  )
}

export default SelectedCampaign
